import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  Table,
  Text,
  Toggle,
} from './styles';

const formatDaysRemaining = (date, today) => {
  if (!date) return 'Eligible';

  const dateFormatted = moment(date, 'YYYY-MM-DD');
  const daysRemaining = moment.duration(dateFormatted.diff(today)).asDays();

  return daysRemaining <= 0 ? 'Eligible' : `${daysRemaining} Days`;
};

const CustomTable = (props) => {
  const {
    testers,
    onUpdateEligibility,
  } = props;

  const today = moment().startOf('day');

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Text.Bold>Tester</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Date of test</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Tester type</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Days until eligible</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Eligibility</Text.Bold>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {!_.isEmpty(testers) && _.map(testers, (tester) => {
          const {
            id,
            eligible,
            eligibleAt,
            lastTestAt,
            user: {
              id: userId,
              guest,
              profile: {
                firstName,
                lastName,
              },
            },
          } = tester;

          const testerName = `${firstName} ${lastName}`;
          const testerType = guest ? 'Guest' : 'PlaybookUx';
          const dateOfTest = eligible ? '-' : (lastTestAt && moment(lastTestAt).format('MM/DD/YYYY')) || '-';

          return (
            <Table.Row key={id}>
              <Table.Cell>
                <Text>{testerName}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{dateOfTest}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{testerType}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>
                  {eligible ? 'Eligible' : formatDaysRemaining(eligibleAt, today)}
                </Text>
              </Table.Cell>

              <Table.Cell>
                <Toggle
                  onChange={() => onUpdateEligibility(userId, !eligible)}
                  checked={eligible}
                  id={id}
                />
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

CustomTable.propTypes = {
  testers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      user: PropTypes.shape({
        id: PropTypes.string,
        profile: PropTypes.shape({
          id: PropTypes.string,
          fisrtName: PropTypes.string,
          lastName: PropTypes.string,
        }),
      }),
    }).isRequired,
  ).isRequired,
  onUpdateEligibility: PropTypes.func.isRequired,
};

export default CustomTable;
